import { jsx as _jsx } from "react/jsx-runtime";
import { UnitSystemProvider } from "../../context";
export const UnitSystemProviderWrapper = ({ units, children, }) => (_jsx(UnitSystemProvider, { value: units, children: children }));
//# sourceMappingURL=UnitSystemProvider.js.map